import React, { useRef, useState } from "react";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

import { putpost, uploadpost } from "services/utils";
import { MdOutlineFileUpload } from "react-icons/md";
import { getUniqueKey } from "../../../../../views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import {
  failureToast,
  successToast,
} from "../../../../../views/pages/manage/common/utils/methods/toasterFunctions/function";
import { endpoint } from "../../../../../views/pages/manage/common/constant";

const SimpleFileUploadButton = ({
  serviceName = "STOCK_BRANCH",
  supportedFileTypes = ["png", "jpeg", "jpg", "pdf"],
  maxAllowedFileSize = 2, // MB
  onUploadSuccess = () => {},
  disabled = false,
  buttonText = "Upload",
}) => {
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const maxFileSizeBytes = maxAllowedFileSize * 1024 * 1024;

  const dataToServer = {
    bulk: false,
    fileName: null,
    docType: "pdf",
    keyValue: `consession_${getUniqueKey()}`,
    serviceName,
  };

  const openFilePicker = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click(); // ← FIX: reliable click
    }
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileType = file.name.split(".").pop().toLowerCase();
    
    if (!supportedFileTypes.includes(fileType)) {
      failureToast(
        `Only ${supportedFileTypes.map((t) => "." + t).join(", ")} allowed`
      );
      return;
    }

    if (file.size > maxFileSizeBytes) {
      failureToast(`Please upload file less than ${maxAllowedFileSize} MB`);
      return;
    }

    uploadFlow(file, fileType);
  };

  const uploadFlow = (file, fileType) => {
    setLoading(true);

    const formData = {
      ...dataToServer,
      fileName: file.name,
      docType: fileType,
    };

    putpost(
      endpoint.fetchS3Url.getUrl,
      (res) => {
        if (res.code === 200 && res.data) {
          uploadToS3(res.data, file);
        } else {
          failureToast("Failed to fetch upload URL");
          setLoading(false);
        }
      },
      (err) => {
        failureToast(err.message || "Error fetching S3 URL");
        setLoading(false);
      },
      formData,
      "post"
    );
  };

  const uploadToS3 = (res, file) => {
    uploadpost(
      res.storage,
      () => {
        successToast("File uploaded successfully");
        setLoading(false);

        onUploadSuccess({
          name: file.name,
          key: res.key,
        });
      },
      () => {
        failureToast("Upload failed, try again later");
        setLoading(false);
      },
      file,
      file.type,
      file.name
    );
  };

  return (
    <>
      {/* Hidden file input */}
      <input
        ref={fileInputRef}
        type="file"
        onChange={handleChange}
        style={{ display: "none" }}
        disabled={loading || disabled}
      />

      {/* Visible button */}
      <AButton
        variant="outline"
        updatedStyle={{ width: "100%" }}
        disabled={loading || disabled}
        onClick={openFilePicker}   // ← FIX: triggers input reliably
        className="cursor-pointer button_remove_left_margin"
      >
        <MdOutlineFileUpload size={20} className="mr-1" />
        {loading ? "Uploading..." : buttonText}
      </AButton>
    </>
  );
};

export default SimpleFileUploadButton;
